import { API_CONFIG, apiUtils } from '../config';

export const getParents = async (page = 1, limit = 100, search = '') => {
  const queryParams = apiUtils.buildQueryString({ page, limit, search });
  const url = `${API_CONFIG.BASE_URL}/parent?${queryParams}`;
  return apiUtils.makeAuthenticatedRequest(url);
};

export const createParent = async (parentData) => {
  const url = `${API_CONFIG.BASE_URL}/parent`;
  return apiUtils.makeAuthenticatedRequest(url, {
    method: 'POST',
    body: JSON.stringify(parentData),
  });
};

export const updateParent = async (parentId, parentData) => {
  const url = `${API_CONFIG.BASE_URL}/parent/${parentId}`;
  return apiUtils.makeAuthenticatedRequest(url, {
    method: 'PUT',
    body: JSON.stringify(parentData),
  });
};

export const deleteParent = async (parentId) => {
  const url = `${API_CONFIG.BASE_URL}/parent/${parentId}`;
  return apiUtils.makeAuthenticatedRequest(url, {
    method: 'DELETE',
  });
};

const parentApi = {
  getParents,
  createParent,
  updateParent,
  deleteParent,
};

export default parentApi;
